import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'ui';
import DateFormat from 'constants/date_format';
import JoinVideoMeetingButton from 'components/InPersonTraining/shared/JoinVideoMeetingButton';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AttendanceStatus from '../../shared/AttendanceStatus';
import SessionDetails from '../../shared/SessionDetails';

const EventsDashboardUpNextEvent = ({ event }) => {
  if (Object.keys(event).length === 0) return null;
  return (
    <div>
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
          {t('in_person_training.events_dashboard.your_next_event')}
        </Text>
      </div>
      <Card
        cap="top"
        url={event.urls.register}
        className="EventsDashboardEvent EventsCardShadow MyTrainingEventsCard ff-ss mb-24 d-b"
      >
        <div className="MyTrainingEventsCard-calendarGraphic d-f ai-c">
          <div className="MyTrainingEventsCard-calendarGraphic--month">
            {moment(
              event.session.startTime,
              DateFormat.fixed.ISO8601_LOCAL,
            ).format(DateFormat.fixed.LONG_MONTH)}
          </div>
          <div className="MyTrainingEventsCard-calendarGraphic--day">
            {moment(
              event.session.startTime,
              DateFormat.fixed.ISO8601_LOCAL,
            ).format(DateFormat.fixed.NUMBER_DAY)}
          </div>
        </div>
        <Card.Content padding="medium">
          <div className="mb-8">
            <Text className="text-wrap" variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
              {event.event.name}
            </Text>
          </div>
          <SessionDetails
            className="mb-8"
            session={event.session}
            eventId={event.event.id}
          />
          <AttendanceStatus status={event.attendance.status} />
          <div>
            <JoinVideoMeetingButton
              className="mt-8"
              rsvpStatus={event.attendance.status}
              session={event.session}
              event={event.event}
            />
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};

const mapStateToProps = state => ({
  event: state.events.nextAttendingEvent,
});

export default connect(mapStateToProps)(EventsDashboardUpNextEvent);
